/*
 * Copyright (C) 2015 Spanning Cloud Apps LLC.  All rights reserved.
 */
/**
 * Service module for common dashboard services/utilities.
 */
'use strict';

angular
  .module('services.dashboard', [])
  /**
   * A factory with common dashboard utilities.
   */
  .factory('dashboardUtils', function (httpDashboard) {
    return {
      /**
       * Returns dashboard preferences for the org.
       *
       * @returns {Promise} A promise that resolves into an array of objects.
       */
      getDashboardPreferences: function () {
        var self = this;
        return httpDashboard.getPrimaryObjects().then(function (primaryObjectsInfo) {
          return self.buildPrimaryObjectArray(primaryObjectsInfo);
        });
      },

      /**
       * Returns all primary dashboard objects for the org.
       *
       * @returns {Promise} A promise that resolves into an array of objects.
       */
      getAllDashboardObjects: function () {
        return httpDashboard.getAvailablePrimaryObjects().then(function (primaryObjects) {
          // We need to return an array of object that contain objectName and objectDisplay to be consistent with whats returned from getDashboardPreferences.
          _.each(primaryObjects, function (primaryObj) {
            /* jshint -W106 */
            primaryObj.objectName = primaryObj.object_name;
            primaryObj.objectDisplay = primaryObj.object_name;
            /* jshint +W106 */
          });
          return primaryObjects;
        });
      },

      /**
       * Set the primary dashboard objects for the org.
       *
       * @param {Array} primaryObjects - The primary objects to set for the org.
       * @returns {Promise} A promise that resolves into a boolean - true on success.
       */
      setPrimaryObjects: function (primaryObjects) {
        var self = this;
        return httpDashboard.setPrimaryObjects(primaryObjects).then(function (response) {
          return self.buildPrimaryObjectArray(response.primaryObjectsInfo);
        });
      },

      /**
       * Utility to build a primary object array that can be iterated over from a primaryObjectInfo object.
       *
       * @param {Object} primaryObjectInfo - The primary object info.
       * @param {String} primaryObjectInfo.object1Name - The name of object1.
       * @param {String} primaryObjectInfo.object1Display - The display name of object1.
       * @param {String} primaryObjectInfo.object2Name - The name of object2.
       * @param {String} primaryObjectInfo.object2Display - The display name of object2.
       * @param {String} primaryObjectInfo.object3Name - The name of object3.
       * @param {String} primaryObjectInfo.object3Display - The display name of object3.
       * @param {String} primaryObjectInfo.object4Name - The name of object4.
       * @param {String} primaryObjectInfo.object4Display - The display name of object4.
       * @returns {Array} - An array of primary objects.
       */
      buildPrimaryObjectArray: function (primaryObjectInfo) {
        var primaryObjectsArray = [],
          newObj;

        for (var i = 1; i < 5; i++) {
          newObj = {
            objectName: primaryObjectInfo['object' + i + 'Name'],
            objectDisplay: primaryObjectInfo['object' + i + 'Display'] || primaryObjectInfo['object' + i + 'Name']
          };

          primaryObjectsArray.push(newObj);
        }

        return primaryObjectsArray;
      }
    };
  });
